import { useSyncExternalStore } from 'react';

/**
 * Custom hook to track media query matches.
 * Uses useSyncExternalStore for proper synchronization with the browser's matchMedia API.
 * @param query - CSS media query string (e.g., '(max-width: 768px)')
 * @returns boolean indicating if the query matches
 */
export function useMediaQuery(query: string): boolean {
    const subscribe = (callback: () => void) => {
        if (typeof window === 'undefined') return () => { };

        const mediaQueryList = window.matchMedia(query);
        mediaQueryList.addEventListener('change', callback);

        return () => {
            mediaQueryList.removeEventListener('change', callback);
        };
    };

    const getSnapshot = () => {
        if (typeof window === 'undefined') return false;
        return window.matchMedia(query).matches;
    };

    const getServerSnapshot = () => false;

    return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
